module.exports = __webpack_public_path__ + "c9e2b730d4bc007ab6d046d43d0fdbea.png";